import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { RestaurantWithEventSpaces } from "@/types/restaurant";
import type { FilterParams } from "@/types/filters";
import { queryKeys, RESTAURANT_SELECT, SSR_STALE_TIME } from "@/lib/queryKeys";
import {
  filterByNeighborhood,
  filterBySearch,
  filterByEventType,
  filterByGroupSize,
  filterByPriceRange
} from "@/utils/filterOperations";

export const useFilteredRestaurants = (filters: FilterParams) => {
  return useQuery({
    queryKey: queryKeys.restaurants(filters),
    staleTime: SSR_STALE_TIME,
    queryFn: async () => {
      console.log('useFilteredRestaurants - Starting filter operation with:', filters);
      
      const { data, error } = await supabase
        .from('restaurants')
        .select(RESTAURANT_SELECT)
        .eq('approval_status', 'approved');

      if (error) {
        console.error('useFilteredRestaurants - Error fetching restaurants:', error);
        throw error;
      }

      let filteredRestaurants = data as RestaurantWithEventSpaces[];

      filteredRestaurants = filterByNeighborhood(filteredRestaurants, filters.neighborhood);
      filteredRestaurants = filterBySearch(filteredRestaurants, filters.search);
      filteredRestaurants = filterByEventType(filteredRestaurants, filters.eventType);
      filteredRestaurants = filterByGroupSize(filteredRestaurants, filters.groupSize);
      filteredRestaurants = filterByPriceRange(filteredRestaurants, filters.priceRange);

      console.log('useFilteredRestaurants - Final results:', {
        initialCount: data.length,
        finalCount: filteredRestaurants.length,
        appliedFilters: Object.entries(filters).filter(([_, value]) => value).length
      });

      return filteredRestaurants;
    },
  });
};
